import {Canvas} from './canvas';

export default typeof Image !== 'undefined' ? Image
  : (Canvas && Canvas.Image || null);



//////////////////
// WEBPACK FOOTER
// ./~/vega-scenegraph/src/util/canvas/image.js
// module id = 1538
// module chunks = 0